import React from "react";
import {observer} from "mobx-react";
import IconButton from '../../comum/components/IconButton'
import {ExcelExport, ExcelExportColumn} from "@progress/kendo-react-excel-export";
import moment from "moment";

@observer
export default class ExportarExcelOsweb extends React.Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.timeRegExp = new RegExp("([0-9]{4}\-[0-9]{2}\-[0-9]{2}T[0-9]{2}\:[0-9]{2}:[0-9]{2})")
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let lista = [];
        if(this.controller.getLista().length > 0){ lista = this.controller.getListaCopia(); } else { lista = [];}
        let desabilita;
        desabilita = lista.length <= 0;

        if(lista.length > 0){
            lista.map(data => {
                const keys = Object.keys(data)
                keys.map(key =>{
                    if(this.timeRegExp.test(data[key]) && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date'){
                        data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm")
                    }
                })
            })
        }

        let cols = this.controller.colunas;
        return (
            <div>
                <IconButton icon="file-excel" text="Baixar XLS" size="md" disabled={desabilita} onClick={this.export} />

                <ExcelExport
                    data={lista}
                    fileName="OSWeb.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }} >
                    { cols.map((coluna, x) => (
                        <ExcelExportColumn
                            key={x}
                            title={coluna.text}
                            field={coluna.dataField}
                        />
                    )) }
                </ExcelExport>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/osweb/components/ExportarExcelOsweb.js